export default function CentreDetailsApi({ makeRequest, buildRequest }) {

    // Hours
    function getCentreHours(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/CentreDetails/Hours/${centreId}`));
        });
    }

    function upsertCentreHours(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/CentreDetails/Hours/Upsert', payload));
        });
    }

    function deleteCentreHours(centreHoursId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/CentreDetails/Hours/${centreHoursId}`));
        });
    }

    // Merchants
    function getCentreMerchants(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/CentreDetails/Merchants/${centreId}`));
        });
    }

    function upsertCentreMerchant(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/CentreDetails/Merchants/Upsert', payload));
        });
    }

    function deleteCentreMerchant(centreMerchantId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/CentreDetails/Merchants/${centreMerchantId}`));
        });
    }

    // Tags
    function getCentreTags(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/CentreDetails/Tags/${centreId}`));
        });
    }

    function upsertCentreTag(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/CentreDetails/Tags/Upsert', payload));
        });
    }

    function deleteCentreTag(centreTagId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/CentreDetails/Tags/${centreTagId}`));
        });
    }

    // Brands
    function getBrands() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/CentreDetails/Brands'));
        });
    }

    function upsertBrand(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/CentreDetails/Brands/Upsert', payload));
        });
    }

    function deleteBrand(brandId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/CentreDetails/Brands/${brandId}`));
        });
    }

    // Centre Types
    function getCentreTypes() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/CentreDetails/CentreTypes'));
        });
    }

    function upsertCentreType(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/CentreDetails/CentreTypes/Upsert', payload));
        });
    }

    function deleteCentreType(centreTypeId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/CentreDetails/CentreTypes/${centreTypeId}`));
        });
    }

    // Centre Statuses
    function getCentreStatuses() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/CentreDetails/CentreStatuses'));
        });
    }

    function upsertCentreStatus(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/CentreDetails/CentreStatuses/Upsert', payload));
        });
    }

    function deleteCentreStatus(centreStatusId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/CentreDetails/CentreStatuses/${centreStatusId}`));
        });
    }

    // Cost Centres
    function getCostCentres() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/CentreDetails/CostCentres'));
        });
    }

    function upsertCostCentre(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/CentreDetails/CostCentres/Upsert', payload));
        });
    }

    function deleteCostCentre(costCentreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/CentreDetails/CostCentres/${costCentreId}`));
        });
    }


    
    return {
        getCentreHours,
        upsertCentreHours,
        deleteCentreHours,
        getCentreMerchants,
        upsertCentreMerchant,
        deleteCentreMerchant,
        getCentreTags,
        upsertCentreTag,
        deleteCentreTag,
        getBrands,
        upsertBrand,
        deleteBrand,
        getCentreTypes,
        upsertCentreType,
        deleteCentreType,
        getCentreStatuses,
        upsertCentreStatus,
        deleteCentreStatus,
        getCostCentres,
        upsertCostCentre,
        deleteCostCentre,
    };
}
